module.exports = __webpack_public_path__ + "media/images/autodesk-make-engagements-great-177d2ae3af69c307ae7bd4130ce74b1db041bc7dfa48866ded8084b7357bec01.png";